// Hook
import { useContext } from 'react';
import { TenantContext } from '../context/TenantContext';

const useTenantConfig = () => {
    return useContext(TenantContext);
}

export default useTenantConfig;